export default {
  attended: 'Atendidos',
  received: 'Recebidos',
};
